import { User } from './user'

export type Customer = {
  _id: string
  name: string
  users_id: string[]
  shipperContacts: {
    _id: string
    companyName: string
    contactPerson: string
    address: string
    phone: string
    email: string
  }[]
  consigneeContacts: {
    _id: string
    companyName: string
    contactPerson: string
    address: string
    phone: string
    email: string
  }[]
  enabledFeatures: string[]
  tier: string
  logexTeam: string
  billingAddress: {
    email: string
  }
  types: string[]
  users: User[]
  segment: string | null
  assignees?: {
    sales?: {
      email?: string
    }
  }
}

export enum CustomerFeature {
  COST_BREAKDOWN = 'COST_BREAKDOWN',
  SUPPLIER_BOOKING = 'SUPPLIER_BOOKING',
  NPS_EMAIL = 'NPS_EMAIL',
  PURCHASE_ORDER_MANAGEMENT = 'PURCHASE_ORDER_MANAGEMENT',
  DANGEROUS_GOODS_AUTO_QUOTE = 'DANGEROUS_GOODS_AUTO_QUOTE',
  NEW_SHIP_UI = 'NEW_SHIP_UI',
  OFFSET_SERVICE = 'OFFSET_SERVICE',
}

export function customerHasFeature(customer: Customer, feature: CustomerFeature): boolean {
  return !!customer.enabledFeatures && customer.enabledFeatures.indexOf(feature) > -1
}
